import { SchoolYear, useSchoolYear } from '@pelckmans/business-components/context/SchoolYearContext';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface SchoolYearValue extends SchoolYear {
  id: string;
  title: string;
}

export type SchoolYearValues = {
  current: SchoolYearValue;
  previous?: SchoolYearValue;
};

export default function useSchoolYearValues() {
  const { currentSchoolYear, previousSchoolYear } = useSchoolYear();

  const { t } = useTranslation();

  const loading = useMemo(() => !previousSchoolYear, [previousSchoolYear]);

  const schoolYears = useMemo<SchoolYearValues | undefined>(() => {
    if (!currentSchoolYear) return undefined;

    return {
      current: {
        ...currentSchoolYear,
        id: `${currentSchoolYear.from.getFullYear()}-${currentSchoolYear.to.getFullYear()}`,
        title: t('SCHOOL_YEAR_VALUES.CURRENT'),
      },
      previous: previousSchoolYear && {
        ...previousSchoolYear,
        id: `${previousSchoolYear.from.getFullYear()}-${previousSchoolYear.to.getFullYear()}`,
        title: t('SCHOOL_YEAR_VALUES.PREVIOUS'),
      },
    };
  }, [previousSchoolYear, currentSchoolYear, t]);

  return { loading, schoolYears };
}
